export const faqData = {
    "faqPageTitle": "SG-Commons FAQ",
    "content": [
      {
        "title": "General Information & Purpose",
        "question_list": [
          {
            "question": "What is the ShikshaGraha Solutions Repository?",
            "answer": "<p>The repository is a compendium of solutions, programs, and assets in the education space, shared by the ShikshaGraha movement partners for public use under Creative Commons Attribution Share-Alike (CC BY-SA) License. It is the curated knowledge base used to ground the Mitra AI Chatbot's responses.</p>"
          },
          {
            "question": "How is the Mitra chatbot from SG-Commons different from ChatGPT or Gemini?",
            "answer": "<p>Mitra is fundamentally different because it is a specialized, interactive Generative AI (GenAI) tool designed specifically for Solution Seekers in the Indian public education sector.</p><ul><li><strong>Grounding and Verification:</strong> Unlike general models, Mitra is grounded exclusively in the SG-Commons' curated knowledge base. This ensures all responses are specific to the education domain and verifiable against specific source documents.</li><li><strong>Purpose and Guidance:</strong> Mitra guides users to create improvement plans through structured conversations.</li><li><strong>Future Capability:</strong> Later phases will enable deeper program design including objectives, M&E rubrics, and asset creation.</li></ul>"
          }
        ]
      },
      {
        "title": "Improvement Projects",
        "question_list": [
          {
            "question": "What is an Improvement Project?",
            "answer": "<p><strong>Improvement Project</strong> is a structured, short-duration intervention designed to address a specific education challenge.</p><ul><li>Multiple objectives can exist for a challenge, each supported by one or more improvement plans.</li><li><strong>Analogy:</strong> Large goals are broken into small, achievable units that build momentum and flexibility.</li></ul>"
          },
          {
            "question": "Why is a Improvement Project needed?",
            "answer": "<p>Improvement projects provide a structured, actionable blueprint for change by breaking large goals into sequential micro-goals. They ensure clarity, accountability, continuous engagement, and measurable outcomes through defined tasks and M&E assets.</p>"
          }
        ]
      },
      {
        "title": "Using the Mitra AI Chatbot",
        "question_list": [
          {
            "question": "What can Mitra currently do and how do I use it?",
            "answer": "<p>Mitra focuses on initial solution design and helps transform challenges into actionable plans.</p><p><strong>Current capabilities include:</strong></p><ol><li>Accepting the challenge statement</li><li>Refining a specific objective</li><li>Generating actionable tasks</li></ol><p><strong>Future Scope:</strong> Generating multiple objectives, full improvement plans, and comprehensive M&E resources.</p>"
          },
          {
            "question": "What are some good questions to ask Mitra in this phase?",
            "answer": "<p>Mitra works best with specific, factual, and solution-oriented questions.</p><ul><li>Improving school attendance</li><li>Increasing parental engagement</li><li>Addressing learning difficulties</li><li>Reducing dropout rates</li><li>Enhancing teacher classroom management skills</li></ul>"
          }
        ]
      },
      {
        "title": "Accuracy, Grounding, and Trust",
        "question_list": [
          {
            "question": "How does Mitra keep its answers grounded in the SG-Commons knowledge sources?",
            "answer": "<p>Mitra uses <strong>Retrieval-Augmented Generation (RAG)</strong>:</p><ol><li>Searches the repository</li><li>Selects relevant information chunks</li><li>Provides only curated content to the AI</li><li>Generates responses strictly from that context</li></ol>"
          },
          {
            "question": "Mitra can make mistakes. How do I safeguard myself against them?",
            "answer": "<p>Mitra may occasionally hallucinate or produce non-contextual results. Safeguards include:</p><ul><li><strong>Checking citations</strong> to verify sources</li><li><strong>Modifying generated plans</strong> to fit your context</li><li><strong>Fact-grounding</strong> decisions using cited documents</li></ul>"
          }
        ]
      }
    ]
  }
  